<template>
    <div class="pa-2">
        <v-card 
            v-if="item.id"
            class="pa-4 ma-0" 
            outlined
        >
            <div class="text-h6">Fac - Código {{ item.codigo }} </div>

            <v-tabs
                v-model="active_tab"
                show-arrows 
            >
                <v-tab href="#tab-10" class="caption"> Principal</v-tab>
              
            </v-tabs>
        
            <v-tabs-items v-model="active_tab">
                <v-tab-item value="tab-10">
                    <v-card flat class="pa-8">
                        <!--main-form :object="item" /-->
                    </v-card>   
                </v-tab-item>   
            </v-tabs-items>
        </v-card>
        
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';


export default {
    name: 'FacEdit',

    components: {
       
    },

    mounted() {
        window.scrollTo(0, 0);
    },       

    data() {
        return {
            active_tab: 'tab-10',

            item: {
                id: null,
            },            
        };
    },

    computed: {
        ...mapGetters('permissions', ['can']),
    },

    watch: {
        // Recarrega se o UUID mudar (navegação interna)
        '$route.params.uuid': {
            async handler(newUuid) {
                if (newUuid) {
                    try {
                        const result = await this.loadFac(newUuid);
                        this.item = result.data;
                        this.setObject()
                    } catch (error) {
                        this.item = null;
                        console.error('Erro:', error);
                    } 
                }
            },
            immediate: true
        },
    },

    methods: {
        ...mapActions(['loadFac']),

        setObject(){
            
        },
    }    
    
};

</script>